import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';

export interface ObservableStateResult<T> {
  data?: T;
  error?: string;
  isLoading?: boolean;
  isEmpty?: boolean;
}

const defaultError = 'Something went wrong';

@Pipe({ name: 'withLoading' })
export class WithLoadingPipe implements PipeTransform {
  transform<T = any>(val: Observable<T>): Observable<ObservableStateResult<T>> {
    return isObservable(val)
      ? val.pipe(
          map((value: any) => {
            return {
              isLoading: value?.type === 'start',
              error: value?.type === 'error' ? defaultError : '',
              data: value?.type ? value.data : value,
              isEmpty: !value,
            };
          }),
          startWith({ isLoading: true }),
          catchError((error) => of({ isLoading: false, error: typeof error === 'string' ? error : defaultError }))
        )
      : val;
  }
}
